import { getApiBasePath } from "@/app/base-path";

export interface GetFacilityLocationsParams {
  digitalVisitReason: string;
  longitude: number;
  latitude: number;
  application: string;
  patientAge?: number;
}

interface FacilityLocationAddress {
  id?: number;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface FacilityLocation {
  facilityCode: string;
  title?: string;
  address?: FacilityLocationAddress | null;
  zipCode?: string | null;
  phone?: string | null;
  distance?: number;
  onHVP?: boolean;
  legalBillingName?: string;
  onP3?: boolean;
  openDate?: string;
}

export async function getFacilityLocations(
  params: GetFacilityLocationsParams,
): Promise<FacilityLocation[]> {
  const response = await fetch(`${getApiBasePath()}/api/facility-locations/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  const responseBody = await response.json();

  if (response.ok) return responseBody as FacilityLocation[];
  throw new Error(`Unexpected response status: ${response.status}`);
}
